import { Injectable } from '@angular/core';
import { LoginContext } from './authentication.service';
import { JwtHelperService } from '@auth0/angular-jwt';

export interface Credentials {
  // Customize received credentials here
  username: string;
  token: string;
  refreshtoken: string;
  expiry: number;
}

export class TokenBody implements LoginContext{
  username: string;
  grant_type: string;
  password: string;
}
const credentialsKey = 'credentials';

/**
 * Provides storage for authentication credentials.
 * The Credentials interface should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  private _credentials: Credentials | null = null;


  constructor(public jwtHelper: JwtHelperService) {
    const savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  /**
   * Checks is the user is authenticated.
   * @return True if the user is authenticated.
   */
  isAuthenticated(): boolean {
      // Check whether the token is expired and return
      // true or false
    try {
      return this._credentials && !this.jwtHelper.isTokenExpired(this._credentials.token);
    } catch (e) {
      return false;
    }
  }

  /**
   * Checks is the refresh token is not expired.
   * @return True if the user is token is not expired.
   */
  isRefreshNotExpired() {
      // Check whether the refresh token is expired and return
      // true or false
    try {
      return this._credentials && !this.jwtHelper.isTokenExpired(this._credentials.refreshtoken);
    } catch (e) {
      return false;
    }
  }
  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */

  get credentials(): Credentials | null {
    return this._credentials;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   * @param remember True to remember credentials across sessions.
   */
  setCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;

    if (credentials) {
      // TODO currently storing in local storage will have to move to cookie
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }
}
